import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			// deviceType: 'pc',
			deviceType: 'mobile',
			showDebug: false,
			ads: {
				home_1: {
					class: 'adsbygoogle',
					style: 'display:block',
					'data-ad-client': 'ca-pub-1406259971309697',
					'data-ad-slot': '',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
				},
				home_recommand: [
					{
						class: 'adsbygoogle',
						style: 'display:block',
						'data-ad-client': 'ca-pub-1406259971309697',
						'data-ad-slot': '',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
					},
					{
						class: 'adsbygoogle',
						style: 'display:block',
						'data-ad-client': 'ca-pub-1406259971309697',
						'data-ad-slot': '',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
					},
				],
				detail_1: {
					class: 'adsbygoogle',
					style: 'display:block',
					'data-ad-client': 'ca-pub-1406259971309697',
					'data-ad-slot': '',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
				},
				detail_2: {
					class: 'adsbygoogle',
					style: 'display:block',
					'data-ad-client': 'ca-pub-1406259971309697',
					'data-ad-slot': '',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
				},
				detail_recommand: [
					{
						class: 'adsbygoogle',
						style: 'display:block',
						'data-ad-client': 'ca-pub-1406259971309697',
						'data-ad-slot': '',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
					},
				],
			},
			adPosConfig: {
				homeRecommand: [2, 5],
				homeRecommandPC: [2, 5],
				detailRecommand: [3],
			},

			adsensConfig: {},
			domainConfig: {
				title: 'Currency Compendium',
				designType: 1,
				bg: 6,
				type: 'CurrencyCompendium',
				IAmIntro: 'Currency Compendium',
				IAmTitle: 'Currency Compendium',
				IAMEMAIL: 'currencycompendium.support@gmail.com',
				IAmURL: 'currencycompendium.org',

				keyword: 'philosophers',

				meta: {
					title: 'Global Currencies and Financial Trends',
					des: 'Comprehensive overview of global currencies, exploring economic histories, exchange rates, and financial trends.',
				},

				ABOUTUS: 'Comprehensive Compendium of Global Currencies and Economic Insights',
				wikiList: [],
			},
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			setWikiList(state, wikiList) {
				state.wikiList = wikiList
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
			wikiList: (state) => state.wikiList,
		},
	})
}
